export default function About() {
  return (
    <div className="w-full max-w-[1280px] max-[1280px]:p-7">
        <p className="text-white text-2xl m-auto jus text-justify max-[450px]:text-xl">Этот сайт посвящён событиям Великой Отечественной войны, отражая стойкость, героизм и силу народов в те трудные годы.</p>
        <p className="text-white text-2xl m-auto jus text-justify mt-5 max-[450px]:text-xl">Вы также найдёте фотодокументы до, во время и после войны, которые символизируют разрушения и последующее возрождение. Кроме того, сайт содержит вдохновляющие истории о людях, чей труд и мужество помогли преодолеть тяготы военного времени.    </p>
    </div>
  );
}